export default __webpack_public_path__ + "static/media/expand_more.8322b254.svg";